import { render, staticRenderFns } from "./RuleSortBtn.vue?vue&type=template&id=5aa44c78&scoped=true"
import script from "./RuleSortBtn.vue?vue&type=script&lang=js"
export * from "./RuleSortBtn.vue?vue&type=script&lang=js"
import style0 from "./RuleSortBtn.vue?vue&type=style&index=0&id=5aa44c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa44c78",
  null
  
)

export default component.exports